import { HTMLAttributes } from 'react'

export const SizeGuide = (props: HTMLAttributes<HTMLDivElement>) => (
  <div {...props} />
)
